export const AccordionIdentifies = Object.freeze({
  Sources: 'sources' as const,
  Feeds: 'feeds' as const,
  Preview: 'preview' as const,
});
